<template>
  <div v-if="isShowable" :class="containerClass">
    <span class="limited-time-sales__label caption-bold">
      期間限定販売：
    </span>
    <span class="limited-time-sales__date body-bold">
      {{ formattedEndedAt }}
    </span>
    <span class="limited-time-sales__suffix caption-bold">
      まで
    </span>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    endedAt: {
      type: String,
      default: ''
    },
    containerClass: {
      type: String,
      default: 'items-show__limited-time-sales-area'
    }
  },
  computed: {
    isShowable() {
      if (!this.endedAt) return false
      const endedAt = dayjs(this.endedAt)
      return endedAt.isValid()
    },
    formattedEndedAt() {
      if (!this.endedAt) return ''
      return dayjs(this.endedAt).format('YYYY年M月DD日 HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.items-show__limited-time-sales-area {
  display: flex;
  width: 100%;
  height: 42px;
  padding: 8px 16px;
  align-items: center;
  gap: 4px;
  background: $primary-lighten;
  box-sizing: border-box;
}

.limited-time-sales {
  &__label {
    color: $brown-1;
    line-height: 1;
  }

  &__date {
    color: $primary;
    line-height: 1;
  }

  &__suffix {
    color: $brown-1;
    line-height: 1;
  }
}
</style>
